import React from 'react';
import axios from 'axios';
import { useRecoilState } from 'recoil';
import { alertState } from '../../../../../utils/recoil/snackbar';
import { UserState } from '../../../../../utils/recoil/user';
import { withLocale } from '../../../../../utils/hocs/withLocale';
import { Form } from '../../../../UI/Forms/Form/form';
import { returnAPISlug } from '../../../../../utils/globals';
import NoozApi from '../../../../../services/NoozApi';

export const ProfileAddressUpdateForm = withLocale(
  ({ successLabels, errorLabels, body, inputs, submitButton, address }) => {
    const [alert, setAlert] = useRecoilState(alertState);
    const [user, setUser] = useRecoilState(UserState);
    const onAddressUpdateSubmit = (data, id) => {
      // 2/12/21 delete id from address, deprecated in the future by shopify
      const formatedAddress = data;
      delete formatedAddress.id;
      setUser({ ...user, isLoading: true });

      if (typeof window !== 'undefined') {
        NoozApi.put(`/addresses/customer/${id}`, formatedAddress)
          .then((response) => {
            setUser({ ...user, isLoading: false });

            if (response.data.address) {
              setAlert({
                ...alert,
                show: true,
                type: 'success',
                title: successLabels[0].text,
              });

              // TODO APPLY USER ADDRESS UPDATE IN RECOIL
            }
          })
          .catch(({ response }) => {
            setAlert({
              ...alert,
              show: true,
              type: 'error',
              title: response?.data.error,
            });
            setUser({ ...user, isLoading: false });
          });
      }
    };

    return (
      <Form
        onSubmit={(data) => onAddressUpdateSubmit(data, address?.id)}
        defaultValues={address}
        isLoading={user.isLoading}
        body={body}
        inputs={inputs}
        submitButton={submitButton}
      />
    );
  }
);
